import React, { Component } from 'react';
import icon_reportDetail_head from "../../images/icon_reportDetail_head.png"
import './index.css'
import icon_arch from "./images/icon_arch.png"
import { withTranslation, WithTranslation } from 'react-i18next';

type StateProps = {
	static: any
}

class StaticFeetSynthesis extends Component<StateProps & WithTranslation> {

	getStaticData() {
		const staticLeft = this.props.static.left
		const staticRight = this.props.static.right

		let both: any = {
			left: {},
			right: {},
		}

		// 左脚全
		both.left = staticLeft.whole
		// 右脚全
		both.right = staticRight.whole
		const i18n = this.props.i18n;

		return [
			{
				name: `${i18n.t('area')}【mm²】`,
				leftData: both.left.area.toFixed(0),
				rightData: both.right.area.toFixed(0)
			},
			{
				name: `${i18n.t('load')}【%】`,
				leftData: (both.left.loadOverBothSide * 100).toFixed(2),
				rightData: (both.right.loadOverBothSide * 100).toFixed(2)
			},
			{
				name: `${i18n.t('maxPressure')}【kPa(r)】`,
				leftData: (both.left.pressureMax / 1000).toFixed(3),
				rightData: (both.right.pressureMax / 1000).toFixed(3)
			},
			{
				name: `${i18n.t('averagePressure')}【kPa(r)】`,
				leftData: (both.left.pressureMean / 1000).toFixed(3),
				rightData: (both.right.pressureMean / 1000).toFixed(3)
			},
		]

	}

	returnText = (feetData) => {

		const i18n = this.props.i18n;

		let areaFront = i18n.t("feetComprehensiveDataAnalyLeft");
		let areaBack = i18n.t("feetComprehensiveDataAnalyRight");
		if (feetData[0].leftData < feetData[0].rightData) {
			areaFront = i18n.t("feetComprehensiveDataAnalyRight");
			areaBack = i18n.t("feetComprehensiveDataAnalyLeft");
		}

		let loadFront = i18n.t("feetComprehensiveDataAnalyLeft");
		let loadBack = i18n.t("feetComprehensiveDataAnalyRight");
		let main = i18n.t("feetComprehensiveDataAnalyLeft");
		if (feetData[1].leftData < feetData[1].rightData) {
			loadFront = i18n.t("feetComprehensiveDataAnalyRight");
			loadBack = i18n.t("feetComprehensiveDataAnalyLeft");
			main = i18n.t("feetComprehensiveDataAnalyRight");
		}

		return i18n.t(
			"feetComprehensiveDataAnaly",
			{
				areaFront,
				areaBack,
				loadFront,
				loadBack,
				main
			}
		)
	}

	render() {

		const feetData = this.getStaticData();
		const text = this.returnText(feetData)
		const i18n = this.props.i18n;

		return (
			<div className="standing-feet-synthesis">
				<p className="reportCom-container-title">
					{/* <img src={icon_reportDetail_head} alt="icon head" /> */}
					<span>{i18n.t('feetComprehensiveData')}</span>
				</p>
				<ul className="container-content">
					<li>
						<p className="container-content-btn">{i18n.t('leftFootSum')}</p>
						<div>
							{feetData.length && feetData.map((item, index) => {
								return (
									<p key={index}>
										<span>{item.name}</span>
										<span>{item.leftData}</span>
									</p>
								)
							})}
						</div>
					</li>
					<li><img src={icon_arch} alt="icon arch" /></li>
					<li>
						<p className="container-content-btn">{i18n.t('rightFootSum')}</p>
						<div>
							{feetData.length && feetData.map((item, index) => {
								return (
									<p key={index}>
										<span>{item.name}</span>
										<span>{item.rightData}</span>
									</p>
								)
							})}
						</div>
					</li>
				</ul>
				<p className="container-text">
					{text}
				</p>
			</div>
		)
	}
}

export default withTranslation()(StaticFeetSynthesis)